module.exports = __webpack_public_path__ + "img/Yossy-Biyantariska.6c97a9b0.png";